import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { Observable, Subject, Subscription } from 'rxjs';

@Injectable()
export class DownloadService {
  private downloadSubscription: Subscription;
  private downloadCompleteSubscription: Subscription;
  
  constructor(private http: HttpClient) { }
  
  public triggerDownload(filePath: string) {
    this.downloadCompleteSubscription = this.downloadFile(filePath)
      .subscribe(
        blob => {
          saveAs(blob, 'Knopf.png');
        }
      );
  }
  
  private downloadFile(filePath: string): Observable<any> {
    let downloadSubject = new Subject<any>();
    
    this.downloadSubscription = this.http.get(filePath, { responseType: 'blob' })
      .subscribe(
        response => {
          downloadSubject.next(response);
          downloadSubject.complete();
        }
      );
    
    return downloadSubject.asObservable();
  }
  
  public ngOnDestroy() {
    if (typeof this.downloadSubscription !== 'undefined') {
      this.downloadSubscription.unsubscribe();
    }
    
    if (typeof this.downloadCompleteSubscription !== 'undefined') {
      this.downloadCompleteSubscription.unsubscribe();
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/global/download/download.service.ts